import Cookies from "js-cookie";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import useAlert from "../../hooks/Alert";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import Alert from "./Alert/Alert";
import Title from "./misc/Title";
import axiosInstance from "../../config/axiosInstance";

function ForgotPasswordNewPassword({ baseURL, clientID }) {
    const navigate = useNavigate();

    const { showAlert, setShowAlert, alertStyle, setAlertStyle, alertMessage, setAlertMessage, hideAlert } = useAlert();

    let userData = {};

    try {
        userData = JSON.parse(Cookies.get("wafaa-user-data-reset-key"));
    } catch (error) {
        navigate("/");
    }

    const isEmail = (data) => /\S+@\S+\.\S+/.test(data);

    const newPassword = useRef();

    const setNewPassword = async () => {
        if (newPassword.current.checkValidity()) {
            const payload = {
                DIV_DES: "",
                DIV_ID: "1",
                FUNCTION: "ChangePWD",
                SEND_KEY: "123456",
                DATA: {
                    [isEmail(userData) ? "EMAIL_ID" : "MOBILE_NUMBER"]: userData,
                    NEW_PASSWORD: newPassword.current.value,
                    CLIENT_ID: clientID,
                },
            };
    
            try {
                const response = await axiosInstance.post(`${baseURL}/ChangePWD`, payload, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
    
                hideAlert();
                setAlertStyle({
                    background: "linear-gradient(to right, #4caf50 0%, #2e7d32 100%)",
                });
                setAlertMessage({
                    success: true,
                    message: "Password reset successfully",
                    mode: "New Password",
                });
                setShowAlert("d-block");
                setTimeout(() => {
                    Cookies.set("wafaa-user-data-reset-email", null);
                    navigate("/");
                }, 1000);
            } catch (error) {
                hideAlert();
                setAlertStyle({
                    background: "linear-gradient(to right, #f6743e 0%, #d42525 100%)",
                });
                setAlertMessage({
                    success: false,
                    message: error.response?.data?.message || "Failed to reset password. Please retry",
                    mode: "New Password",
                });
                setShowAlert("d-block");
            }
        } else {
            hideAlert();
            setAlertStyle({
                background: "linear-gradient(to right, #f6743e 0%, #d42525 100%)",
            });
            setAlertMessage({
                success: false,
                message: "Invalid password input",
                mode: "New Password",
            });
            setShowAlert("d-block");
        }
    };
    return (
        <AnimatedPage>
            <Title />
            <Alert showAlert={showAlert} alertStyle={alertStyle} alertMessage={alertMessage} hideAlert={hideAlert} />
            <div className="bg-white vh-100 d-flex flex-column justify-content-between px-4 py-5">
                <div>
                    <p className="font-size-18 font-weight-bolder">New Password</p>
                    <input className="bg-wafaa-grey border-0 rounded-2 mt-4 ps-2 py-3 shadow-wafaa-btn-inset form-control" placeholder="Enter new password" ref={newPassword} required type="password" />
                </div>
            </div>
            <div className="position-absolute d-flex flex-column justify-content-end p-4 w-100 bottom-0">
                <button
                    type="button"
                    className="w-100 btn btn-lg py-2-5 btn-primary bg-wafaa-purple border-wafaa-purple shadow-wafaa-btn font-size-12"
                    onClick={() => {
                        setNewPassword();
                    }}
                >
                    Continue
                </button>
            </div>
        </AnimatedPage>
    );
}

export default ForgotPasswordNewPassword;